import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useJobFunctionFilter } from './useJobFunctionFilter';

export const JobFunctionFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, jobFunctionOptions, selected } = useJobFunctionFilter({
    setFilters,
    value,
  });

  return (
    <Formik
      initialValues={{ jobFunctionOption: selected || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="jobFunctionOption"
          label="Job function"
          placeholder="Job function"
          size="small"
          component={FormSelect}
          options={jobFunctionOptions}
          anchorToBody
          selectedOption={selected}
        />
      </Form>
    </Formik>
  );
};

JobFunctionFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
};

JobFunctionFilter.defaultProps = {
  value: '',
};
